import { createApi } from '@reduxjs/toolkit/query/react';
import { GetModulesBelongedToOrganization} from '../../api/endpoints';
import {baseQueryWithReauth} from "../../api/baseQuery";

export const getModulesApi =  createApi({
    reducerPath:'getModulesApi',
    baseQuery: baseQueryWithReauth,
endpoints:(builder)=>({
  getModulesBelongedToOrg:builder.query({
      query:()=>({url:GetModulesBelongedToOrganization, method:'GET'}),
      providesTags: [{ type: 'Modules', id: 'GET' }],
  })
})

})

export const {useGetModulesBelongedToOrgQuery} = getModulesApi;